import { isRejectedWithValue } from '@reduxjs/toolkit';
import { showGlobalError } from './uiSlice';

/**
 * Redux middleware that listens for RTK Query rejections and dispatches global error state
 */
export const rtkQueryErrorLogger = (api) => (next) => (action) => {
    // If the action is an RTK Query rejection
    if (isRejectedWithValue(action)) {
        const error = action.payload;

        // Extract message
        let errorMessage = 'An unexpected error occurred';
        let statusCode = error?.status || null;
        let errorDetails = null;

        if (error) {
            if (error.data?.error && Array.isArray(error.data.error)) {
                const valErrors = error.data.error.map(err => err.msg || err.message || JSON.stringify(err)).join(', ');
                errorMessage = `${error.data.message || 'Validation failed'}: ${valErrors}`;
            } else {
                const rawErrorMsg = error.data?.message || error.data?.error || (typeof error.data === 'string' ? error.data : null) || error.message || errorMessage;
                errorMessage = typeof rawErrorMsg === 'string' ? rawErrorMsg : JSON.stringify(rawErrorMsg);
            }
            errorDetails = error.data?.details || (error.data && typeof error.data !== 'string' ? JSON.stringify(error.data, null, 2) : null);
        }

        // Special case for logout/auth errors to avoid flashing modal if redirecting
        // Only show if it's NOT a 401/token error, OR if it's the login page
        // EXCEPT: always skip "no token provided" error as requested
        const isLoginPage = typeof window !== 'undefined' && window.location.pathname.includes('/login');
        const isAuthError = statusCode === 401 || (errorMessage.toLowerCase().includes('token') && !errorMessage.toLowerCase().includes('onboarding'));
        const isNoTokenError = errorMessage.toLowerCase().includes('no token provided');
        
        if (isNoTokenError || (isAuthError && !isLoginPage)) {
            // Silence auth errors if not on login page as they should trigger redirect or logout
            // AND always silence "no token provided" errors
            return next(action);
        }

        // Dispatch global error
        api.dispatch(showGlobalError({
            statusCode,
            errorMessage,
            errorDetails
        }));
    }

    return next(action);
};
